class VideoPopup extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.modal');
    this.modalDialog = this.querySelector('.modal-dialog');
    this.modalSwiperWrap = this.querySelector('[data-modal-swiper]');

    this.videoPlaceholders = this.querySelectorAll('.video-placeholder');
    this.videos = [];

    this.modalSwiper = new Swiper(this.modalSwiperWrap, {
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      direction: 'vertical',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        320: { direction: 'vertical' },
        1024: { direction: 'horizontal' }
      },
      on: {
        slideChange: () => {
          this.videos.forEach(video => video.pause());
          setTimeout(() => {
            const activeSlide = this.modalSwiperWrap.querySelector(`.swiper-slide-active`);
            const video = activeSlide.querySelector('video');
            if (video) {
              video.load();
              video.controls = true;
              video.play();
            }
          }, 100);
        }
      }
    });

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      speed: 300,
      spaceBetween: 12,
      slidesPerView: 2.5,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        320: { slidesPerView: 2.5, spaceBetween: 12 },
        1024: { slidesPerView: 5, spaceBetween: 15 }
      }
    });

    this.socials = this.querySelectorAll('.video-popup--social');
    this.socials.forEach(social => {
      social.addEventListener('click', e => e.stopPropagation());
    });

    this.querySelectorAll('.youtube-embed').forEach(clickable => {
      clickable.addEventListener('click', () => {
        const index = clickable.dataset.index;
        this.modalSwiper.slideToLoop(index);
        this.injectAndPlayVideo(index);
        jQuery(this.modal).modal('show');
      });
    });

    jQuery(this.modalDialog).on('click', e => {
      if (e.target === e.currentTarget) {
        jQuery(this.modal).modal('hide');
      }
    });

    jQuery(this.modal).on('show.bs.modal', () => {
      const shogunRoot = document.querySelector('.shogun-root');
      if (shogunRoot) {
        shogunRoot.style.zIndex = 'initial';
        shogunRoot.style.isolation = 'initial';
      }
    });

    jQuery(this.modal).on('shown.bs.modal', () => {
      this.modalSwiper.animating = false;
    });

    setTimeout(() => {
      jQuery(this.modal).on('hidden.bs.modal', () => {
        this.videos.forEach(video => {
          video.controls = false;
          video.pause();
        });
        const shogunRoot = document.querySelector('.shogun-root');
        if (shogunRoot) {
          shogunRoot.style.zIndex = '1';
          shogunRoot.style.isolation = 'isolate';
        }
      });
    }, 500);
  }

  injectAndPlayVideo(index) {
    const slideEl = this.modalSwiperWrap.querySelector(`.swiper-slide[data-index="${index}"]`);
    let video = slideEl.querySelector('video');

    if (!video) {
      const placeholder = slideEl.querySelector('.video-placeholder');
      const src = placeholder.dataset.videoSrc;
      const mime = placeholder.dataset.mimeType;

      video = document.createElement('video');
      video.className = 'wrapper-rug';
      video.setAttribute('width', '100%');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('preload', 'auto');

      const source = document.createElement('source');
      source.src = src;
      source.type = mime;

      video.appendChild(source);
      placeholder.replaceWith(video);
      this.videos.push(video);
    }

    video.load();
    video.play();
  }
}

customElements.define('video-popup', VideoPopup);